export default "__VITE_ASSET__CO$XTAjN__"